<template>
<div class="jm-md-view" v-html="markdown">
</div>
</template>

<script>
import marked from 'marked'

export default {
	name: "JmMarkdownViewer",
	props: {
		text: String,
		sanitize: {type: Boolean, default: true},
	},
	computed: {
		markdown () {
			return this.text ? marked(this.text, {sanitize: this.sanitize}) : "";
		}
	}
};
</script>

<style lang="stylus" scoped>
max-height 30em
overflow auto
img
	height auto
	margin-top: 1rem;
	margin-bottom: 1rem;
	border-radius: 5px;
	box-shadow: 0 0 1em gray;
	max-width 95%
</style>
